import { onCLS, onINP, onLCP, onFCP, onTTFB } from 'web-vitals'
import { captureException } from '../lib/errorTracking'
import { logger } from '../lib/logger'

interface WebVitalMetric {
  name: string
  value: number
  rating: string
}

const sendMetric = (metric: WebVitalMetric): void => {
  if (import.meta.env.DEV) {
    logger.info(`[WebVitals] ${metric.name}: ${metric.value} (${metric.rating})`)
  }

  if (import.meta.env.PROD && metric.rating === 'poor') {
    captureException(new Error(`Poor web vital: ${metric.name}`), {
      metricName: metric.name,
      metricValue: metric.value,
      metricRating: metric.rating,
    })
  }
}

export function reportWebVitals(): void {
  onCLS(sendMetric)
  onINP(sendMetric)
  onLCP(sendMetric)
  onFCP(sendMetric)
  onTTFB(sendMetric)
}
